import React from "react";
import "./Pricing.css";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

function Pricing() {
  return (
    <div className="div">
      <Header />

      <div className="pricing-container">
        <div className="pricing-header">
          <h1>Tarifs & Services</h1>
          <p className="pricing-subtitle">
            Une expérience photo inoubliable pour vos événements
          </p>
        </div>

        <div className="pricing-grid">
          <div className="pricing-card">
            <div className="pricing-card-header">
              <h2>Photobooth : Forfait Journée/Soirée</h2>
              <p className="pricing-highlight">Notre offre la plus populaire</p>
            </div>
            <div className="pricing-card-price">
              <span className="price">200€</span>
              <span className="duration">1 jour</span>
            </div>
            <div className="pricing-card-features">
              <ul>
                <li>400 impressions</li>
                <li>Cadre personnalisé</li>

                <li>Galerie en ligne privée</li>
              </ul>
            </div>
            <a href="/book">
              <button className="booking-button">Réserver maintenant</button>
            </a>
          </div>

          <div className="pricing-card featured">
            <div className="pricing-card-header">
              <h2>Photobooth : Forfait Weekend</h2>
              <p className="pricing-highlight">Meilleur rapport qualité-prix</p>
            </div>
            <div className="pricing-card-price">
              <span className="price">300€</span>
              <span className="duration">2 jours</span>
            </div>
            <div className="pricing-card-features">
              <ul>
                <li>Cadre personnalisé</li>

                <li>Galerie en ligne privée</li>
              </ul>
            </div>
            <a href="/book">
              <button className="booking-button featured-button">
                Réserver maintenant
              </button>
            </a>
          </div>

          <div className="pricing-card">
            <div className="pricing-card-header">
              <h2>Photobooth : Forfait sur mesure</h2>
              <p className="pricing-highlight">A la carte</p>
            </div>
            <div className="pricing-card-price">
              <span className="price">350€</span>
              <span className="duration">3 jours et plus</span>
            </div>
            <div className="pricing-card-features">
              <ul>
                <li>Installation et configuration incluses</li>
                <li>Cadre personnalisé</li>

                <li>Galerie en ligne privée</li>

                <li>50% de réduction sur la livraison</li>
                <li>Location longue durée</li>
              </ul>
            </div>
            <a href="/book">
              <button className="booking-button">Réserver maintenant</button>
            </a>
          </div>
        </div>

        <div className="additional-equipment">
          <h2>Matériel additionnel</h2>
          <p className="equipment-subtitle">
            Complétez votre location avec notre matériel professionnel de sonorisation et d'ambiance
          </p>

          <div className="equipment-pricing-grid">
            <div className="equipment-pricing-card">
              <div className="equipment-pricing-image">
                <img src={require("../img/JBL 710 PNG.webp")} alt="Enceinte JBL PartyBox 710" />
              </div>
              <div className="equipment-pricing-info">
                <h3>JBL PartyBox 710</h3>
                <p className="equipment-quantity">x1</p>
                <div className="equipment-pricing-price">
                  <span className="price-amount">50€</span>
                  <span className="price-period">/jour</span>
                </div>
                <a href="/book" className="equipment-book-button">Réserver</a>
              </div>
            </div>

            <div className="equipment-pricing-card">
              <span className="special-offer-badge">Offre spéciale</span>
              <div className="equipment-pricing-image">
                <img src={require("../img/Double enceinte JBL 710 PNG.png")} alt="Double enceinte JBL PartyBox 710" />
              </div>
              <div className="equipment-pricing-info">
                <h3>Double JBL 710</h3>
                <p className="equipment-quantity">x2</p>
                <div className="equipment-pricing-price">
                  <span className="price-amount">80€</span>
                  <span className="price-period">/jour</span>
                </div>
                <a href="/book" className="equipment-book-button">Réserver</a>
              </div>
            </div>

            <div className="equipment-pricing-card">
              <div className="equipment-pricing-image">
                <img src={require("../img/Smog Machine PNG.png")} alt="Machine à fumée" />
              </div>
              <div className="equipment-pricing-info">
                <h3>Machine à fumée</h3>
                <p className="equipment-quantity">x1</p>
                <div className="equipment-pricing-price">
                  <span className="price-amount">40€</span>
                  <span className="price-period">/jour</span>
                </div>
                <a href="/book" className="equipment-book-button">Réserver</a>
              </div>
            </div>

            <div className="equipment-pricing-card">
              <div className="equipment-pricing-image">
                <img src={require("../img/Stroboscope PNG.png")} alt="Stroboscope 1500W" />
              </div>
              <div className="equipment-pricing-info">
                <h3>Stroboscope 1500W</h3>
                <p className="equipment-quantity">x1</p>
                <div className="equipment-pricing-price">
                  <span className="price-amount">20€</span>
                  <span className="price-period">/jour</span>
                </div>
                <a href="/book" className="equipment-book-button">Réserver</a>
              </div>
            </div>
          </div>

          <div className="additional-services">
            <h3>Services additionnels</h3>
            <div className="services-grid">
              <div className="service-card">
                <div className="service-icon">
                  <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
                    <path d="M18,18.5a1.5,1.5 0 0,1 -1.5,-1.5a1.5,1.5 0 0,1 1.5,-1.5a1.5,1.5 0 0,1 1.5,1.5a1.5,1.5 0 0,1 -1.5,1.5m1.5,-9l1.96,2.5H17V9.5m-11,9a1.5,1.5 0 0,1 -1.5,-1.5a1.5,1.5 0 0,1 1.5,-1.5a1.5,1.5 0 0,1 1.5,1.5a1.5,1.5 0 0,1 -1.5,1.5M20,8h-3V4H3C1.89,4 1,4.89 1,6v11h2a3,3 0 0,0 3,3a3,3 0 0,0 3,-3h6a3,3 0 0,0 3,3a3,3 0 0,0 3,-3h2v-5L20,8Z" />
                  </svg>
                </div>
                <h4>Livraison & installation</h4>
                <div className="service-price">
                  <span className="price-amount">50€</span>
                </div>
              </div>

              <div className="service-card">
                <div className="service-icon">
                  <svg viewBox="0 0 24 24" width="48" height="48" fill="currentColor">
                    <path d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />
                  </svg>
                </div>
                <h4>Rouleau de papier supplémentaire</h4>
                <p className="service-description">+400 photos</p>
                <div className="service-price">
                  <span className="price-amount">100€</span>
                </div>
              </div>
            </div>
            <div className="services-cta">
              <a href="/book">
                <button className="booking-button secondary-button">
                  Contactez-nous
                </button>
              </a>
            </div>
          </div>
        </div>

        <div className="pricing-faq">
          <h2>Questions fréquentes</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Que comprend exactement le forfait de base ?</h3>
              <p>
                Tous nos forfaits incluent des accessoires, des déguisements,
                des cadres personnalisés illimités, et une assistance technique
                par téléphone.
              </p>
            </div>
            <div className="faq-item">
              <h3>Et la livraison ?</h3>
              <p>
                Une livraison est possible en fonction de votre localisation
                avec un supplément, précisez le dans votre réservation. Dans le
                cadre de la livraison, nous installons le matériel pour vous.
              </p>
            </div>
            <div className="faq-item">
              <h3>Puis-je personnaliser davantage mon expérience ?</h3>
              <p>
                Absolument ! Contactez-nous pour discuter de vos besoins
                spécifiques et nous vous proposerons une offre sur mesure.
              </p>
            </div>
          </div>
        </div>

        <div className="pricing-cta">
          <h2>Prêt à créer des souvenirs inoubliables ?</h2>
          <p>Réservez dès maintenant notre WoodyBooth pour votre événement</p>
          <a href="/book">
            <button className="booking-button large-button">
              Réserver maintenant
            </button>
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Pricing;
